// 작업자 호소 폼 조건부 필수 검증 — '호소 있음' 선택 시:
//   1) [호소 유형] 체크박스 3개 중 적어도 1개 체크
//   2) [증상 호소 있음] 체크 시 [호소 증상] 선택 필수
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { alertId: String }

  validate(event) {
    const form = this.element
    const hasComplaintRadio = form.querySelector('input[type="radio"][name$="[has_complaint]"]:checked')
    const hasComplaint = hasComplaintRadio && hasComplaintRadio.value === "true"
    if (!hasComplaint) return  // '호소 없음' 이면 추가 검증 불필요

    const anyTypeChecked =
      this._cb(form, "has_symptom_complaint") ||
      this._cb(form, "has_exposure_concern") ||
      this._cb(form, "has_other_complaint")

    const symptomChecked = this._cb(form, "has_symptom_complaint")
    const symptomEl = form.querySelector('input[name$="[symptom]"]') ||
                      form.querySelector('select[name$="[symptom]"]')
    const symptomFilled = symptomEl && symptomEl.value.trim() !== ""

    let message = null
    if (!anyTypeChecked) {
      message = "[호소 유형] 중 적어도 하나를 선택해주세요."
    } else if (symptomChecked && !symptomFilled) {
      message = "[호소 증상] 을 선택해주세요."
    }

    if (message) {
      event.preventDefault()
      event.stopImmediatePropagation()
      event.stopPropagation()
      const alertEl = document.getElementById(this.alertIdValue)
      if (alertEl) {
        const msgEl = alertEl.querySelector("[data-alert-target='body'] p")
        if (msgEl) msgEl.textContent = message
        alertEl.dispatchEvent(new CustomEvent("alert:open"))
      }
    }
  }

  _cb(form, name) {
    const el = form.querySelector(`input[type="checkbox"][name$="[${name}]"]`)
    return el && el.checked
  }
}
